import { all } from 'redux-saga/effects';
import { dashboardSaga } from 'sagas/dashboard';
import { selectListSaga } from 'sagas/selectlist';

export function* rootSaga() {
  yield all([dashboardSaga(), selectListSaga()]);
}
